import { EProductType } from '@quesmed/types/models';

export const colorPalette = [
  'red',
  'teal',
  'coral',
  'green',
  'blue',
  'violet',
  'purple',
  'cyan',
  'brown',
  'orange',
  'pink',
  'yellow',
  'indigo',
  'gray',
  'lime',
  'maroon',
  'navy',
  'olive',
  'aqua',
  'fuchsia',
  'gold',
  'silver',
  'beige',
  'lavender',
  'turquoise',
  'peach',
  'chocolate',
  'crimson',
  'plum',
  'orchid',
  'limegreen',
  'aquamarine',
  'saddlebrown',
  'slateblue',
  'peru',
  'seashell',
  'midnightblue',
  'darkgreen',
  'forestgreen',
  'steelblue',
  'lightsalmon',
  'lightgreen',
];

export const productToColor: Record<string, string> = {
  [EProductType.QBANK]: colorPalette[0],
  [EProductType.OSCE]: colorPalette[2],
  [EProductType.BUNDLE]: colorPalette[3],
  [EProductType.ANATOMY]: colorPalette[4],
  [EProductType.MEDICAL_SCIENCES]: colorPalette[5],
  [EProductType.ANATOMY_BUNDLE]: colorPalette[6],
  [EProductType.MRCP_PART1]: colorPalette[7],
  [EProductType.MRCP_PART2]: colorPalette[8],
  [EProductType.PACES]: colorPalette[9],
  [EProductType.MSRA]: colorPalette[10],
  [EProductType.INTERVIEW_ANAESTHETICS]: colorPalette[11],
  [EProductType.INTERVIEW_CST]: colorPalette[12],
  [EProductType.INTERVIEW_IMT]: colorPalette[13],
  [EProductType.INTERVIEW_RADIOLOGY]: colorPalette[14],
  [EProductType.INTERVIEW_PAEDIATRICS]: colorPalette[15],
  [EProductType.INTERVIEW_ACCS]: colorPalette[16],
  [EProductType.PLAB1]: colorPalette[17],
  [EProductType.PLAB2]: colorPalette[18],
  [EProductType.MRCP_BUNDLE]: colorPalette[19],
  [EProductType.MRCP_VIDEO]: colorPalette[20],
  [EProductType.UCAT]: colorPalette[21],
  [EProductType.UNDERGRAD_BUNDLE]: colorPalette[22],
  [EProductType.COMPLETE_CLINICAL_BUNDLE]: colorPalette[23],
};
